export default "__VITE_ASSET__FBL81WoW__"